/** Thrown for any malformed address, prefix, or CIDR input. */
export class InvalidAddressError extends Error {
  constructor(
    public readonly input: string,
    reason: string,
  ) {
    super(`Invalid address "${input}": ${reason}`)
    this.name = 'InvalidAddressError'
  }
}
